import LegalPageLayout from "../../components/LegalPageLayout";

const H2 = ({ children }) => (
  <h2 className="font-serif text-[17px] text-[#1A1A1A] font-semibold mt-8 mb-3 first:mt-0">{children}</h2>
);
const P = ({ children }) => (
  <p className="font-sans text-[14px] text-[#1A1A1A]/75 leading-[1.75] mb-3">{children}</p>
);
const Li = ({ children }) => (
  <li className="font-sans text-[14px] text-[#1A1A1A]/75 leading-[1.75] pl-1">{children}</li>
);

const ReturnsPage = () => (
  <LegalPageLayout title="Возврат / обмен">
    <H2>Отмена заказа в течении 1 часа</H2>
    <P>После оплаты заказ считается подтверждённым и уходит в обработку. Если вы передумали — у вас есть 1 час на отмену. Это можно сделать:</P>
    <ul className="list-disc list-inside space-y-1 mb-4">
      <Li>С менеджером в WhatsApp</Li>
      <Li>Или через наш чат поддержки (в рабочее время)</Li>
    </ul>
    <P>После истечения этого времени отмена невозможна, так как заказ уже передан на сборку и доставку. В этом случае возврат возможен только в исключительных случаях — если есть брак или ошибка с нашей стороны.</P>
    <P>Мы не можем внести изменения в заказ после оформления: заменить размер, цвет или удалить товар. Вы можете отменить заказ в течение первого часа и оформить новый с нужными параметрами.</P>

    <H2>Возврат по браку или ошибке</H2>
    <P>Мы тщательно проверяем товары перед отправкой, но если всё же произошла ошибка — пожалуйста, сообщите нам. Мы обязательно решим вопрос.</P>
    <P>Что считается браком:</P>
    <ul className="list-disc list-inside space-y-1 mb-4">
      <Li>Для одежды: значимые дефекты внешнего вида (пятна, дыры, кривой крой или пошив, выцветание)</Li>
      <Li>Для обуви: деформации, мешающие носке (неровная подошва, дефекты стельки и т.д.)</Li>
    </ul>
    <P>Что считается ошибкой магазина:</P>
    <ul className="list-disc list-inside space-y-1 mb-4">
      <Li>Прислан не тот размер, цвет или модель</Li>
    </ul>
    <P>Следы клея, незначительные нитки, мелкие нюансы отделки — не являются браком, так как допустимы производителем в условиях массового фабричного пошива.</P>

    <H2>Что нельзя вернуть</H2>
    <P>Подарочные и предоплаченные карты</P>
    <P>Товары, полностью соответствующие описанию и заказу (если не подошёл размер или передумали) Возврат таких товаров невозможен, так как они отправляются напрямую из США, и не успеют вернуться в установленные сроки возврата, действующие в американских магазинах.</P>

    <H2>Отмена заказа со стороны магазина</H2>
    <P>Мы выкупаем ваши заказы напрямую из бутиков и аутлетов США. Иногда случается, что товар заканчивается на складе, и это становится известно только на этапе упаковки. Тогда магазин отменяет заказ и возвращает деньги.</P>
    <P>Если это произойдёт — мы сразу сообщим вам об этом. Как только магазин вернёт нам средства, мы оперативно переведём их обратно на ту карту, с которой была произведена оплата. Всё прозрачно, без лишних действий с вашей стороны.</P>
    <P>Если у вас возник вопрос или спорная ситуация — напишите нам. Мы на вашей стороне и всегда готовы помочь.</P>
  </LegalPageLayout>
);

export default ReturnsPage;
